module.exports = __webpack_public_path__ + "media/BubbleSort_slow.7abe7278.mp4";